<template></template>
<script>
export default {
	name: "InputBase",
	methods: {
		setSelectedOptionToStore(key, value) {
			this.$store.dispatch("configurator/setSelectedOption", {
				key: key,
				value: value
			});
		},
		setValidationStatusToStore(optionId, isValid) {
			this.$store.dispatch("configurator/setStepOptionStatus", { optionId: optionId, status: isValid });
		},
		isValid(isRequiredOption, value) {
			return !isRequiredOption || value ? true : false;
		},
		updateValidationStatus(option, value) {
			this.setValidationStatusToStore(option.id, this.isValid(option.input.required, value));
		}
	}
};
</script>